import { MessagingConfirmationModal } from 'components/Modal/MessagingConfirmationModal';
import { deleteTemplateFromTemplateManager } from 'store/action/templates';
import { useAppDispatch, useAppState } from 'store/configureStore';

interface ConfirmDeleteTemplateModalProps {
  isOpen: boolean;
  onClose: () => void;
  templateToDelete: string | null;
  setTemplateToDelete: (templateId: string | null) => void;
}

export const ConfirmDeleteTemplateModal = (props: ConfirmDeleteTemplateModalProps) => {
  const { isOpen, onClose, templateToDelete, setTemplateToDelete } = props;
  const cancelDeleteTemplate = () => onClose();
  const {
    templates: {
      isTemplateDeleting,
      template: { id },
    },
    app: { selectedPractice },
  } = useAppState();
  const dispatch = useAppDispatch();
  const selectedTemplateId = id;
  const selectedPracticeId = selectedPractice?.id;
  const confirmDeleteTemplate = () => {
    if (isTemplateDeleting && templateToDelete === selectedTemplateId) {
      return null;
    }
    if (selectedTemplateId && selectedPracticeId) {
      setTemplateToDelete(selectedTemplateId);
      deleteTemplateFromTemplateManager(selectedTemplateId, dispatch, selectedPracticeId);
    }
    return onClose();
  };
  return (
    <MessagingConfirmationModal
      isOpen={isOpen}
      onClose={cancelDeleteTemplate}
      onCancel={cancelDeleteTemplate}
      onConfirm={confirmDeleteTemplate}
      questionText="Are you sure you want to delete this template? If this is a shared template, it will be deleted for everyone."
      confirmText="Yes, delete"
      cancelText="Keep template"
      idPrefix="cancel-delete-template"
      dataAutomation="confirm-delete-modal"
    />
  );
};
